import React, { FunctionComponent, memo, useState } from 'react';
import { IMeetingSimple } from '../../../../../../../app/resource/meeting-simple/meeting-simple.types';
import { FaChevronDown, FaChevronRight } from 'react-icons/fa6';
import { IMeetingTemplate } from '../../../../../../../app/resource/meeting-templates/meeting-templates.types';
import { useSelectWithParams } from '../../../../../../../utils/selector.utils';
import { agendaItemsPageSelectors } from '../../../../../../../app/page/page-storage/agenda-items/agenda-items.selectors';
import { agendaItemSelectors } from '../../../../../../../app/resource/agenda-item/agenda-item.selectors';
import { IoIosArrowDroprightCircle } from 'react-icons/io';
import { useSelector } from 'react-redux';
import { GoDotFill } from 'react-icons/go';
import { IMeetingListProps } from './types';

const MeetingList: FunctionComponent<IMeetingListProps> = ({ meetings, onSelect }) => {
  return (
    <ul>
      {meetings.map((meeting) => meeting && <MeetingDetails key={meeting.id} meeting={meeting} onSelect={onSelect} />)}
    </ul>
  );
};

const MeetingDetails = ({
  meeting,
  onSelect,
}: {
  meeting: IMeetingSimple | IMeetingTemplate;
  onSelect: (sourceMeetingId: IMeetingSimple['id'], agendaItems: any) => void;
}) => {
  const agendaItemIds = useSelector(agendaItemsPageSelectors.selectAgendaItems);
  let agendaItems = useSelectWithParams(
    agendaItemSelectors.selectResourcesById,
    agendaItemIds[meeting.id] ? agendaItemIds[meeting.id] : [],
  );
  const [open, setOpen] = useState<boolean>(false);

  if ('agendaItems' in meeting) {
    agendaItems = meeting.agendaItems;
  }
  return (
    <>
      <li className="align-center flex justify-between px-2" style={{ height: 50 }}>
        <div className="flex align-center h100 pointer" onClick={() => setOpen(!open)}>
          {open ? (
            <>
              <FaChevronDown className="mr-1" color="#66717c" />
              <span>{meeting.title}</span>
            </>
          ) : (
            <>
              <FaChevronRight className="mr-1" color="#66717c" />
              <span>{meeting.title}</span>
            </>
          )}
        </div>
        <div className="align-center flex h100 pointer">
          <IoIosArrowDroprightCircle
            color="var(--theme-primary-color)"
            size={22}
            className="pointer"
            onClick={() => onSelect(meeting.id, agendaItems)}
          />
        </div>
      </li>
      {open && (
        <li>
          <ul className="pl-4">
            {agendaItems.map(
              (agendaItem) =>
                agendaItem && (
                  <li key={agendaItem.id} className="align-center flex p-2">
                    <GoDotFill />
                    <span className="ml-1">{agendaItem?.title}</span>
                  </li>
                ),
            )}
          </ul>
        </li>
      )}
    </>
  );
};
export default memo(MeetingList);
